export const ZOOM_ONE_PRO_MONTHLY_PLAN_CODES = ['zo_pro_monthly', 'monthly_c50'];
export const ZOOM_ONE_PRO_ANNUAL_PLAN_CODES = ['zo_pro_yearly', 'yearly_c50'];
export const ZOOM_ONE_PRO_PLAN_CODES = [ZOOM_ONE_PRO_MONTHLY_PLAN_CODES, ZOOM_ONE_PRO_ANNUAL_PLAN_CODES];
